import { render, staticRenderFns } from "./marginCallArray.vue?vue&type=template&id=6a3661ab&scoped=true&"
import script from "./marginCallArray.vue?vue&type=script&lang=js&"
export * from "./marginCallArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3661ab",
  null
  
)

export default component.exports